import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { 
    TOTAL_STATUS_PROCCESSING, 
    TOTAL_STATUS_REVIEW 
} from "../../../../../utils/constant";
import { Iconfont } from "../../../../../../../components/icon/iconfont";
import { FormattedMessage, useIntl } from "react-intl";
import Copy from "copy-to-clipboard";
import { useCallback } from "react";
import Toast from "../../../../../../../components/toast";
import moment from "moment";
import { useDispatch } from "react-redux";
import { action_fetch_order_detail } from "../../../../../../../../store/actions/pages/customer";
import SendToSubscribe from "../../../../../../components/subscribe/index";

const MessageReminder = props =>{

    return <div className={cls.MessageReminder}>
        <div className={cls.Hd}>
            <div>
                <Iconfont className={cls.Icon} dangerouslySetInnerHTML={{__html: props.icon}}></Iconfont>
            </div>
            <div>
                <span className={cls.Font}>{props.title}</span>
            </div>
        </div>

        <div className={cls.Content}>
            {props.children}
        </div>
    </div>
}

const OrderMessage = props =>{
    const { orderDetail } = props;
    const Intl = useIntl();
    const dispatch = useDispatch();

    const copyHandle = useCallback((orderId) =>{
        if(Copy(orderId)){
            Toast(Intl.formatMessage({ id: "copy_success", defaultMessage: "Copy successful" }));
        }
    }, []);

    const backToRelatedOrder = useCallback((orderId) =>{
        dispatch(action_fetch_order_detail(orderId));
    }, []);

    return <div className={cls.OrderMessage}>
        <div className={cls.MessageItem}>
            <div>
                <span className={cls.Font}><FormattedMessage id="order_no" defaultMessage="Order No" />.</span>
            </div>

            <div>
                <span className={cls.Font}>{orderDetail?.id}</span>
                <Iconfont onClick={()=>copyHandle(orderDetail?.id)} className={cls.Icon}>&#xe776;</Iconfont>
            </div>
        </div>

        {
            orderDetail?.relatedOrderId && <div className={cls.MessageItem}>
                <div>
                    <span className={cls.Font}><FormattedMessage id="related_order_no" defaultMessage="Related Order No" />.</span>
                </div>

                <div onClick={()=>backToRelatedOrder(orderDetail.relatedOrderId)}>
                    <span className={cls.Font}>{orderDetail.relatedOrderId}</span>
                    <Iconfont className={`${cls.Icon} ${cls.RelateIcon}`}>&#xe690;</Iconfont>
                </div>
            </div>
        }
        

        <div className={`${cls.MessageItem} ${cls.BorderNone}`}>
            <div>
                <span className={cls.Font}><FormattedMessage id="payment_date" defaultMessage="Payment Date" />.</span>
            </div>

            <div>
                <span className={cls.Font}>{moment(orderDetail?.orderTime).format('DD/MM/YYYY HH:mm:ss')}</span>
            </div>
        </div>
    </div>
}

export default props =>{
    useStyles(cls);
    const { orderDetail, customer } = props;
    const Intl = useIntl();

    const hasQuickShip = orderDetail?.logistics?.packages?.some?.(parcel => parcel?.products?.some(p => p.isDomesticDelivery))

    return <div className={cls.OrderDetailMessage}>
        {
            orderDetail.fulfillmentStatus === TOTAL_STATUS_PROCCESSING && <React.Fragment>
                <MessageReminder 
                    icon={'&#xe6a6'} 
                    title={Intl.formatMessage({ id: "your_package_is_packed", defaultMessage: "Your package is being packed" })}
                >
                    <FormattedMessage id="it_normally_process_your_order" defaultMessage="It normally takes 3-7 business days for us to process your order." />
                    {
                    hasQuickShip && <><span style={{color:'#3AAF43'}}>'QuickShip'</span> will provide a faster delivery service between 3-6 business days.</>
                    }
                    <a href="/policy/shipping-policy"><FormattedMessage id="learn_more" defaultMessage="Learn More" /></a>
                </MessageReminder>
            </React.Fragment>
        }

        {
            orderDetail.fulfillmentStatus === TOTAL_STATUS_REVIEW && <React.Fragment>
                <MessageReminder 
                    icon={'&#xe6a5'} 
                    title={Intl.formatMessage({ id: "your_package_signed_for", defaultMessage: "Your package has been signed for." })}
                >
                    <FormattedMessage id="if_you_cosutomer_services" defaultMessage="If you have any questions, please contact customer service." />
                </MessageReminder>
            </React.Fragment>
        }

        {
            customer?.id && <React.Fragment>
                <SendToSubscribe 
                    country={orderDetail?.shippingDetail?.country?.value} 
                    customer={customer} 
                    phoneNumber={orderDetail.shippingDetail?.phoneNumber}
                />
            </React.Fragment>
        }

        <OrderMessage orderDetail={orderDetail} />
    </div>
}